import {take, select, fork, put} from 'redux-saga/effects';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from './updateServiceAssignment';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';

const selectServiceAssignmentTowingDestinationFlow = function* selectServiceAssignmentTowingDestinationFlow() {
    const {serviceManager} = yield select(state => state.application);
    const googleMapsService = serviceManager.loadService('googleMapsService');

    while (true) {
        const {payload} = yield take(serviceAssignmentActionTypes.SUBMIT_TOWING_DESTINATION_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, serviceCaseId, isUpdateNeeded = true} = payload;
        const {serviceCases} = yield select(state => state.serviceCases);
        const serviceCase = serviceCases[serviceCaseId];

        if (isUpdateNeeded) {
            yield* updateServiceAssignment({
                caller: serviceAssignmentActionTypes.SUBMIT_TOWING_DESTINATION_FORM,
                assignmentType: efServiceAssignmentTypes.VEHICLE,
                serviceAssignmentLineNo,
                serviceCaseId,
                serviceAssignmentData,
            });
        }

        if (!serviceCase || !serviceCase.damage?.location || !serviceAssignmentData.towingDestination) continue;

        const damageLocation = serviceCase.damage.location;

        yield fork(
            fetchRequest,
            serviceAssignmentActionTypes.FETCH_DAMAGE_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST,
            googleMapsService.getRoute,
            {
                origin: {
                    location: {
                        latLng: {
                            latitude: damageLocation.latitude,
                            longitude: damageLocation.longitude,
                        },
                    },
                },
                destination: {
                    location: {
                        latLng: {
                            latitude: serviceAssignmentData.towingDestination.latitude,
                            longitude: serviceAssignmentData.towingDestination.longitude,
                        },
                    },
                },
                fields: ['routes.distanceMeters', 'routes.duration', 'routes.polyline.encodedPolyline'],
            },
        );
        const routeResponseAction = yield take([
            serviceAssignmentActionTypes.FETCH_DAMAGE_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_FAILED,
            serviceAssignmentActionTypes.FETCH_DAMAGE_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_SUCCEEDED,
        ]);

        if (!routeResponseAction.error) {
            const {response} = routeResponseAction.payload;
            const {routes} = response;
            const routeToReferentialPoint = routes[0];

            if (routeToReferentialPoint) {
                yield put({
                    type: serviceAssignmentActionTypes.SET_SELECTED_TOWING_DESTINATION_ROUTE,
                    payload: {
                        serviceAssignmentId: `${serviceCaseId}-${serviceAssignmentLineNo}`,
                        selectedTowingDestinationLocationId: serviceAssignmentData.towingDestination.id,
                        selectedTowingDestinationRoute: {
                            totalKilometers: routeToReferentialPoint.distanceMeters / 1000,
                            totalTravelTime: Number(routeToReferentialPoint.duration.replace('s', '')) / 60,
                            encodedPolyline: routeToReferentialPoint.polyline.encodedPolyline,
                        },
                    },
                });
            }
        }
    }
};

export default selectServiceAssignmentTowingDestinationFlow;
